'use client';

import type { TextInputProps } from '../text-input';

import { forwardRef, useState } from 'react';

import { TextInput } from '../text-input';

export type PercentInputProps = Omit<TextInputProps, 'onChange' | 'value'> & {
  onChange: (value: string) => void;
  step?: number;
  value?: number;
};

const DEFAULT_STEP = 0.05;

export const roundToNearestStep = (value: number, step: number): number =>
  Math.round(value / step) * step;

export const baseOnePercentToPercent = (value: number | undefined): string =>
  value === undefined ? '' : (value * 100).toFixed(2);

export const percentToBaseOnePercent = (value: number): string =>
  (value / 100).toFixed(4);

export const PercentInput = forwardRef<HTMLInputElement, PercentInputProps>(
  ({ onChange, step = DEFAULT_STEP, value, ...props }, ref) => {
    const [displayValue, setDisplayValue] = useState(
      baseOnePercentToPercent(value ?? 0)
    );

    return (
      <TextInput
        {...props}
        ref={ref}
        inputMode="decimal"
        rightIcon="percent"
        step={step}
        type="number"
        value={displayValue}
        onBlur={({ target: { value } }) => {
          const numValue = Number(value);
          if (!isNaN(numValue)) {
            const roundedValue = roundToNearestStep(numValue, step);
            setDisplayValue(roundedValue.toFixed(2));
            onChange(percentToBaseOnePercent(roundedValue));
          }
        }}
        onChange={({ target: { value } }) => {
          const numValue = Number(value);
          setDisplayValue(value);
          if (!isNaN(numValue)) {
            onChange(percentToBaseOnePercent(numValue));
          }
        }}
      />
    );
  }
);

PercentInput.displayName = 'PercentInput';
